import React from 'react'
import {Container, Img, Title,Text, Price, BuyBtn, PriceContainer, Rate,CrossedDicount,ImgWrapper,DisountWrapper} from "./style"
import food from "../../assets/imgs/food.png"


function ProductCard({discount, title, price, description}) {
  return (
    <Container>
      <ImgWrapper>
     
       <Rate> {discount && '- 36%'}</Rate>
       <Img src={food} />
      </ImgWrapper>
    
      <Title>{title}</Title>
      <Text>
        { description|| "Space for a small product descreption"}
      </Text>
      <PriceContainer>
        <DisountWrapper>
           <Price>{`${price} USD`}</Price> 
           { discount && <CrossedDicount>{discount}</CrossedDicount>}
        </DisountWrapper>
        <BuyBtn>Buy now</BuyBtn>
      </PriceContainer>
    </Container>   
  )
}

export default ProductCard
